export enum FormTemplateTypeEnum {
    LifeInsurance = 1,
    MortgageProtection = 2,
    IncomeProtection = 3,
    SeriousIllnessProtection = 4,
    Mortgages = 5,
    Pensions = 6,
    FinancialPlanning = 7,
    SavingsandInvestments = 8,
    HealthInsurance = 9,
    HealthQuestionnaire = 10,
    FactFind = 11,
    ReasonWhy = 12
}